import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import {
  currentAssignedFormId,
  hasRecentLoginAttempt,
  loginUrl,
  markLoginAttempt,
} from '../utils/assigned-form-auth';

// Keyed off the current page's assigned-form id (not the request URL) so submit calls are also covered.
export const errorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      const assignedFormId = currentAssignedFormId();
      if (err.status === HttpStatusCode.Unauthorized || err.status === HttpStatusCode.Forbidden) {
        if (assignedFormId) {
          if (hasRecentLoginAttempt(assignedFormId)) {
            // returned from login still 401 — cookie not sticking, stop loop
            window.location.href = `/?authError=session&formId=${assignedFormId}`;
          } else {
            markLoginAttempt(assignedFormId);
            window.location.href = loginUrl(assignedFormId);
          }
        }
      } else if (assignedFormId) {
        let code: string;
        if (err.status === HttpStatusCode.NotFound) {
          code = 'form-not-found';
        } else if (err.status === HttpStatusCode.Gone) {
          code = 'form-cancelled';
        } else {
          code = 'server-error';
        }
        window.location.href = `/?authError=${code}&formId=${assignedFormId}`;
      }
      return throwError(() => err);
    }),
  );
};
